import type { SendMoneyRecipientAccount } from "../../types/sendMoney";

const KEY = "sendMoney.selectedRecipient";

export const loadSelectedRecipient = (): SendMoneyRecipientAccount | null => {
  try {
    const raw = sessionStorage.getItem(KEY);
    return raw ? (JSON.parse(raw) as SendMoneyRecipientAccount) : null;
  } catch {
    return null;
  }
};

export const saveSelectedRecipient = (value: SendMoneyRecipientAccount): void => {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    /* storage unavailable — non-fatal */
  }
};

export const clearSelectedRecipient = (): void => {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* non-fatal */
  }
};